import gql from 'graphql-tag';
import situationFragment from '../fragments/situation';
import deviceFragment from '../fragments/device';

const GET_SITUATION_BY_ID = gql`
  query GetSituationById($situationId: ID!) {
    getSituationById(id: $situationId) {
      ...situationDetails
      conversationId
      deviceId
      device {
        id
        name
        image
        uniqueId
        workspacePrefix {
          id
          prefix
        }
        lastDevicePosition
        type
        lastDeviceEvent
        connectionStatus
        devicePlaces {
          place {
            coordinate
          }
        }
      }
    }
  }
  ${situationFragment.SITUATION}
`;

const GET_SITUATIONS_BY_IDS = gql`
  query GetSituationsByIds($situationIds: [ID!]!) {
    getSituationsByIds(situationIds: $situationIds) {
      ...situationDetails
      conversationId
      device {
        id
        name
        image
        type
        workspacePrefixId
        workspacePrefix {
          id
          prefix
        }
        uniqueId
      }
      deviceHistories {
        id
        data
        deviceId
        isSelfGenerated
        eventId
        receivedAt
        generatedAt
        devicePositionId
        cctvRelated {
          device {
            id
            name
            config
            workspaceId
          }
          channel {
            id
            channelId
            description
          }
        }
        device {
          id
          name
          image
          uniqueId
          workspacePrefix {
            id
            prefix
          }
        }
        event {
          id
          code
          technicalDescription
          color
          priority
          eventGroup {
            id
            name
          }
        }
      }
    }
  }
  ${situationFragment.SITUATION}
`;

const GET_SITUATIONS_BY_IDS_MINIMAL = gql`
  query GetSituationsByIdsMinimal($situationIds: [ID!]!) {
    getSituationsByIds(situationIds: $situationIds) {
      ...situationListDetails
      conversationId
      device {
        id
        name
        image
        type
        workspacePrefixId
        workspacePrefix {
          id
          prefix
        }
        uniqueId
      }
    }
  }
  ${situationFragment.SITUATION_LIST}
`;

// One situation's log for the history log modal. Same monitoring endpoint (and
// authorization) that loads the Traffic situations above, projected to the log.
const GET_SITUATION_LOG = gql`
  query GetSituationLog($situationIds: [ID!]!) {
    getSituationsByIds(situationIds: $situationIds) {
      id
      log
    }
  }
`;

const CHECK_HEALTH_MONITORING = gql`
  query CheckHealth($userId: ID!, $workspaceId: ID!) {
    checkHealth(userId: $userId, workspaceId: $workspaceId)
  }
`;

const CHECK_HEALTH_MAPS = gql`
  query checkHealthMaps($token: ID!, $id: ID, $name: String) {
    checkHealthMaps(token: $token, id: $id, name: $name)
  }
`;

const GET_WORKSPACE_SITUATIONS_HEATMAP = gql`
  query GetWorkspaceSituationsHeatmap(
    $workspaceId: ID!
    $timezone: String
    $weekOffset: Int
  ) {
    getWorkspaceSituationsHeatmap(
      workspaceId: $workspaceId
      timezone: $timezone
      weekOffset: $weekOffset
    ) {
      weekStart
      weekEnd
      buckets {
        dayIndex
        hour
        count
      }
    }
  }
`;

const GET_DEVICE_HISTORIES_BY_SITUATION_ID = gql`
  query GetDeviceHistoriesBySituationId(
    $situationId: ID!
    $take: Int
    $skip: Int
    $sort: DeviceHistorySortInput
    $filter: DeviceHistoryFilterInput
  ) {
    getDeviceHistoriesBySituationId(
      situationId: $situationId
      take: $take
      skip: $skip
      sort: $sort
      filter: $filter
    ) {
      deviceHistories {
        id
        data
        deviceId
        isSelfGenerated
        eventId
        receivedAt
        generatedAt
        devicePosition {
          ...devicePositionDetails
        }
        cctvRelated {
          device {
            id
            name
            config
            workspaceId
          }
          channel {
            id
            channelId
            description
          }
        }
        event {
          id
          code
          technicalDescription
          color
          priority
          eventGroup {
            id
            name
          }
        }
        situationId
      }
      aggregate {
        rows
      }
    }
  }
  ${deviceFragment.FRAGMENT_DEVICE_POSITION}
`;

const GET_CALL_RECORDING_CHUNK_URLS = gql`
  query GetCallRecordingChunkUrls($callId: ID!, $chunkKeys: [String!]!) {
    getCallRecordingChunkUrls(callId: $callId, chunkKeys: $chunkKeys)
  }
`;

export default {
  GET_SITUATION_BY_ID,
  GET_SITUATIONS_BY_IDS,
  GET_SITUATIONS_BY_IDS_MINIMAL,
  GET_SITUATION_LOG,
  CHECK_HEALTH_MONITORING,
  CHECK_HEALTH_MAPS,
  GET_WORKSPACE_SITUATIONS_HEATMAP,
  GET_DEVICE_HISTORIES_BY_SITUATION_ID,
  GET_CALL_RECORDING_CHUNK_URLS,
};
